import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { PanelTitle, CoverageWidget } from 'ui';
import { getESGCoverage } from 'selectors/common';
import { esgCoveragePercentagesParser } from 'shared/parsers/esg/esgCoveragePercentagesParser';

const HomeESGCoverage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data, isPending } = useSelector(getESGCoverage);

  const onItemClick = (id) => navigate(`/esg-coverage/${id}`);
  return (
    <>
      <PanelTitle>{t('ESG coverage')}</PanelTitle>
      <CoverageWidget
        data={esgCoveragePercentagesParser(data)}
        loading={isPending}
        onItemClick={onItemClick}
        tooltip={t('% of MSCI World covered by Scope')}
      />
    </>
  );
};

export { HomeESGCoverage };
